<script setup lang="ts">
import type { Component } from 'vue';

/**
 * Renders one filter option through the registry entry's `optionComponent`.
 *
 * It exists so the prop contract has a single implementation. The two filter
 * controls each render options twice, in their list and in their closed control,
 * and those four copies had already drifted: FilterEnumSelect did not pass
 * `option`, which TagFilterOption reads for the kind colour and the group name,
 * so the same registry entry drew a coloured, grouped tag in one control and a
 * plain name in the other.
 *
 * Callers keep their own fallback for the no-component case, because what to show
 * instead differs: a count, a placeholder, or the raw stored value.
 */
defineProps<{
  component: Component;
  value: string;
  label: string;
  /** The whole option, for components that read more than the value and label. */
  option?: unknown;
}>();
</script>

<template>
  <component :is="component" :value="value" :label="label" :option="option" size="sm" />
</template>
